import { render, staticRenderFns } from "./IconPageFirst.vue?vue&type=template&id=5c91fde8&"
import script from "./IconPageFirst.vue?vue&type=script&lang=js&"
export * from "./IconPageFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports